import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faSms, faThList } from '@fortawesome/free-solid-svg-icons'
import { push } from 'connected-react-router'

import Premium from '../user/premium.js'
import DateFormat from '../utils/dateFormat'
import { fetchAvailabilityRequests } from '../../actions/availabilityRequestsActions'
import Tabs from '../utils/Tabs'

const tabOptions = [
  { name: 'Active', value: 'active' },
  { name: 'Expired', value: 'expired' }
]

const connected = connect(store => {
  return {
    isAuthenticated: store.session.isAuthenticated,
    user: store.user.user,
    premium: store.user.premium,
    requests: store.availabilityRequests.ars,
    requestsExpired: store.availabilityRequests.arsExpired,
    fetching: store.availabilityRequests.fetching,
    fetched: store.availabilityRequests.fetched
  }
})

const Requests = ({ dispatch, requests, requestsExpired, fetching }) => {
  const [expired, setExpired] = useState(false)
  const [contentActive, setContentActive] = useState('active')

  useEffect(() => {
    if ((expired ? requestsExpired : requests).length === 0) {
      dispatch(fetchAvailabilityRequests(expired))
    }
  }, [expired])

  useEffect(() => {
    setExpired(contentActive === 'expired')
  }, [contentActive])

  const mappedArs = () => {
    return (expired ? requestsExpired : requests).map(ar => {
      return (
        <div
          key={ar.uuid}
          className="flex space-x-4 border-b border-gray-300 hover:bg-gray-100 p-2 cursor-pointer"
          onClick={() => dispatch(push(`/${ar.uuid}`))}
        >
          <div className="flex flex-col flex-grow">
            <div className="text-2xl font-semibold">{ar.facility.name}</div>
            <div className="text-lg text-gray-500">
              <DateFormat format="MM/DD" date={ar.date_start} />
              &nbsp;to&nbsp;
              <DateFormat format="MM/DD/YYYY" date={ar.date_end} />
            </div>
            {ar.status === 'paused' && (
              <span className="text-lg font-semibold text-red-400">
                Request Paused{ar.paused_reason && ':'} {ar.paused_reason}
              </span>
            )}
          </div>

          {ar.premium && ar.notify_sms && <FontAwesomeIcon icon={faSms} className="flex text-3xl" />}
          {ar.notify_email && <FontAwesomeIcon icon={faEnvelope} className="flex text-3xl" />}

          {ar.matches_availabile_count > 0 && (
            <div>
              <span className="inline shadow p-2 text-lg font-semibold rounded-full text-white bg-green-600">
                {ar.matches_availabile_count}
              </span>
            </div>
          )}
        </div>
      )
    })
  }

  return (
    <div className="lg:flex lg:space-x-6 mt-4 mb-12">
      <div className="lg:w-1/2 lg:mb-0 mb-6">
        <div className="flex">
          <FontAwesomeIcon icon={faThList} className="flex text-4xl mr-4" />
          <div className="flex text-3xl font-semibold justify-center">Your Requests:</div>
        </div>

        <Tabs options={tabOptions} onChange={setContentActive} />

        {fetching && <div className="my-12 text-gray-400 text-2xl font-semibold">Loading....</div>}

        {!fetching && (expired ? requestsExpired : requests).length > 0 && (
          <ul className="flex flex-col mt-4 space-y-2 overflow-y-auto">{mappedArs()}</ul>
        )}
        {!fetching && (expired ? requestsExpired : requests).length === 0 && (
          <div className="my-12 text-gray-400 text-2xl font-semibold">No requests found</div>
        )}
      </div>
      <div className="lg:w-1/2">
        <Premium />
      </div>
    </div>
  )
}

export default connected(Requests)
